import { createContext, useCallback, useState } from 'react'

import { DocumentForm, InfoBox, MfaCode, MfaOptions } from './components'
import * as S from './styles'
import type { BillFormFields, FormRouteComponent, FormRouteObject, DuplicateBillContextProps } from './types'

export const DuplicateBillContext = createContext<DuplicateBillContextProps>({} as DuplicateBillContextProps)

export const DuplicateBillForm = () => {
  // Maybe use user instead of fields?
  const [fields, setFields] = useState<BillFormFields>({
    document: '',
    contract: ''
  })
  const [route, setRoute] = useState<FormRouteObject>({
    Component: DocumentForm
  })

  const changeCallback = useCallback(
    (field: string, value: string) => {
      setFields({ ...fields, [field]: value })
    },
    [fields]
  )

  const getComponent = (componentType: string): FormRouteComponent => {
    switch (componentType) {
      case 'info':
        return InfoBox
      case 'mfa-code':
        return MfaCode
      case 'mfa-options':
        return MfaOptions
      case 'form':
      default:
        setFields({
          document: '',
          contract: ''
        })
        return DocumentForm
    }
  }

  const routeCallback = useCallback((component: string, params?: object) => {
    const newRoute: FormRouteObject = { Component: getComponent(component) }
    if (params) newRoute.params = params

    setRoute(newRoute)
  }, [])

  return (
    <DuplicateBillContext.Provider
      value={{
        fields,
        changeCallback,
        routeCallback
      }}
    >
      <S.FormWrapper>
        <route.Component {...route.params}></route.Component>
      </S.FormWrapper>
    </DuplicateBillContext.Provider>
  )
}
